import bootstarpUiTimeFormTemplate from './bootstrap_ui_time_form.html';
import bootstrapUiDateTimeFormTemplate from './bootstrap_ui_datetime_form.html';
import bootstrapUiPhoneNumberFormTemplate from './bootstrap_ui_phonenumber_form.html';
import priceFormTemplate from './price_form.html';
import dateFormTemplate from './date_form.html';
import radiosTemplate from './radios.html';
import radiosInlineTemplate from './radios_inline.html';
import radiosButtonsTemplate from './radio_buttons.html';
import colorpickerTemplate from './colorpicker.html';
import selectPriceTemplate from './select-price.html';
import checkPriceTemplate from './check_price.html';

function schemaFormConfig(schemaFormProvider, schemaFormDecoratorsProvider, sfPathProvider) {
    'ngInject';

    const timepicker = function (name, schema, options) {
        if ((schema.type === 'string') && (schema.format === 'time')) {
            const f = schemaFormProvider.stdFormObj(name, schema, options);
            f.key = options.path;
            f.type = 'timepicker';
            options.lookup[sfPathProvider.stringify(options.path)] = f;
            return f;
        }
    };

    schemaFormProvider.defaults.string.unshift(timepicker);

    const datetimepicker = function (name, schema, options) {
        if ((schema.type === 'string') && (schema.format === 'datetime')) {
            const f = schemaFormProvider.stdFormObj(name, schema, options);
            f.key = options.path;
            f.type = 'datetime';
            options.lookup[sfPathProvider.stringify(options.path)] = f;
            return f;
        }
    };

    schemaFormProvider.defaults.string.unshift(datetimepicker);

    const phonenumber = function (name, schema, options) {
        if ((schema.type === 'string') && (schema.format === 'tel')) {
            const f = schemaFormProvider.stdFormObj(name, schema, options);
            f.key = options.path;
            f.type = 'phonenumber';
            options.lookup[sfPathProvider.stringify(options.path)] = f;
            return f;
        }
    };

    schemaFormProvider.defaults.string.unshift(phonenumber);

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'time',
        bootstarpUiTimeFormTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'time',
        bootstarpUiTimeFormTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'datetime',
        bootstrapUiDateTimeFormTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'datetime',
        bootstrapUiDateTimeFormTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'phonenumber',
        bootstrapUiPhoneNumberFormTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'phonenumber',
        bootstrapUiPhoneNumberFormTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'price',
        priceFormTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'price',
        priceFormTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'select',
        selectPriceTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'select',
        selectPriceTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'select-price',
        selectPriceTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'select-price',
        selectPriceTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'radio-price',
        radiosTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'radio-price',
        radiosTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'check-price',
        checkPriceTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'check-price',
        checkPriceTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'date',
        dateFormTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'date',
        dateFormTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'radios',
        radiosTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'radios',
        radiosTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'radios-inline',
        radiosInlineTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'radios-inline',
        radiosInlineTemplate.id
    );

    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'radiobuttons',
        radiosButtonsTemplate.id
    );

    schemaFormDecoratorsProvider.createDirective(
        'radiobuttons',
        radiosButtonsTemplate.id
    );

    const colorpicker = (name, schema, options) => {
        if (schema.type === 'string' && schema.format == 'color') {
            const f = schemaFormProvider.stdFormObj(name, schema, options);
            f.key  = options.path;
            f.type = 'colorpicker';
            options.lookup[sfPathProvider.stringify(options.path)] = f;
            return f;
        }
    };

    schemaFormProvider.defaults.string.unshift(colorpicker);

    schemaFormDecoratorsProvider.createDirective(
        'colorpicker',
        colorpickerTemplate.id
    );
    schemaFormDecoratorsProvider.addMapping(
        'bootstrapDecorator',
        'colorpicker',
        colorpickerTemplate.id
    );
}

export default schemaFormConfig;


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/-config/schema-form/schema_form.config.js